<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Schedule of Activities</h2>
    </div>
    <div class="closebutton mt-1">
      <span class="tooltip-wrapper pointer" style="float:right">
        <i class="cursor-pointer fa fa-times" @click.prevent="closePage()"></i>
        <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 px-2 mt-2">

        <div class="ibox-content horizondalscroll" id="scrollBody">
          <div v-if="armList.length === 0" class="text-center py-5">
            <h4>{{ $t("navigations.no arms available for this study") }}</h4>
          </div>
          <ul v-else class="tree pl-1 flex-arms m-0">
            <!-- Arm Loop -->
            <li v-for="arm in armList" :key="arm.ArmCode" class="arm-column">

              <div class="arm-action pt-1">
                <button :popovertarget="`arm-popup-` + arm.ArmCode" :anchor="`arm-popup-` + arm.ArmCode"
                 
                  class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                  <i class="fa fa-ellipsis-v"></i>
                </button>

                <div :id="`arm-popup-` + arm.ArmCode" popover class="tmf-docs-popup-menu">
                  <button class="popup-menu-block text-start" @click.prevent="handleCreateVisit(arm.ArmCode)">
                    Create Visit
                  </button>
                </div>
              </div>

              <input type="checkbox" :id="arm.ArmCode" @change="toggleArm(arm.ArmCode)" />

              <label :for="arm.ArmCode" class="tree_label">
                {{ arm.ArmName }}
              </label>

              <ul>
                <template v-for="(visit, vIndex) in visitList[arm.ArmCode]" :key="visit.visitId">

                  <!-- PHASE FOLDER -->
                  <li v-if="visit.studyPhase && isFirstPhaseVisit(visitList[arm.ArmCode], visit.studyPhase, vIndex)">

                    <input
                      type="checkbox"
                      :id="'phase-' + visit.studyPhase + '-' + arm.ArmCode"
                    />

                    <label
                      class="tree_label"
                      :for="'phase-' + visit.studyPhase + '-' + arm.ArmCode"
                    >
                       {{ visit.studyPhase }}
                    </label>

                    <ul>
                      <li v-for="v in visitList[arm.ArmCode].filter(x => x.studyPhase === visit.studyPhase)"
                          :key="v.visitId">

                        <div class="arm-action pt-1">

                          <div class="position-relative">
                            <button
                              :popovertarget="'visit-popup-' + v.visitId"
                              :anchor="'visit-popup-' + v.visitId"
                              class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-0">
                              <i class="fa fa-ellipsis-v"></i>
                            </button>

                            <div :id="'visit-popup-' + v.visitId" popover class="tmf-docs-popup-menu" @click.stop>
                              <button class="popup-menu-block text-start" @click.prevent="visitPopup(v.visitId, arm.ArmCode)">
                                {{ $t('navigations.edit') }}
                              </button>

                              <button class="popup-menu-block text-start" @click.prevent="deleteVisit(v.visitId)">
                                {{ $t('navigations.delete') }}
                              </button>

                              <button class="popup-menu-block text-start" @click.prevent="openVisitActivityModal(v.visitId)">
                                {{ $t('navigations.assign activity') }}
                              </button>
                            </div>
                          </div>

                        </div>

                        <input type="checkbox"
                              :id="v.visitId"
                              @change="toggleVisit(arm.armId, v.visitId)" />

                        <label class="tree_label" :for="v.visitId">
                          {{ v.visitNo }} : {{ v.visitFormName }}
                        </label>

                        <!-- Activities -->
                        <ul>
                          <li v-for="activity in activityList[v.visitId]" :key="activity.activityId">
                            <input type="checkbox"
                                  :id="activity.activityId + arm.ArmCode"
                                  @change="toggleActivity(activity.activityId,arm.ArmCode)" />

                            <label :for="activity.activityId + arm.ArmCode" class="tree_label">
                              {{ activity.activityOrder }} : {{ activity.activityName }}
                            </label>

                            <ul>
                              <li v-for="form in formList[activity.activityId + arm.ArmCode]"
                                  :key="form.templateId"
                                  class="p-0">

                                <div class="form-item" @click="viewForms(form.templateId)">
                                  <input type="checkbox" :id="form.templateId" @click.stop />
                                  <label :for="form.templateId" class="tree_form">
                                    {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 
                                  </label>
                                </div>

                              </li>
                            </ul>
                          </li>
                        </ul>

                      </li>
                    </ul>
                  </li>

                  <!--  NORMAL VISIT (NO PHASE) -->
                  <li v-else-if="!visit.studyPhase">

                    <div class="arm-action pt-1">

                      <div class="position-relative">
                        <button
                          :popovertarget="'visit-popup-' + visit.visitId"
                          :anchor="'visit-popup-' + visit.visitId"
                          class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-0">
                          <i class="fa fa-ellipsis-v"></i>
                        </button>

                        <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>
                          <button class="popup-menu-block text-start" @click.prevent="visitPopup(visit.visitId, arm.ArmCode)">
                            {{ $t('navigations.edit') }}
                          </button>

                          <button class="popup-menu-block text-start" @click.prevent="deleteVisit(visit.visitId)">
                            {{ $t('navigations.delete') }}
                          </button>

                          <button class="popup-menu-block text-start" @click.prevent="openVisitActivityModal(visit.visitId)">
                            {{ $t('navigations.assign activity') }}
                          </button>
                        </div>
                      </div>

                    </div>

                    <input type="checkbox"
                          :id="visit.visitId"
                          @change="toggleVisit(arm.armId, visit.visitId, vIndex)" />

                    <label class="tree_label" :for="visit.visitId">
                      {{ visit.visitNo }} : {{ visit.visitFormName }}
                    </label>

                    <!-- keep your existing activity + form structure unchanged -->
                    <ul>
                      <li v-for="activity in activityList[visit.visitId]" :key="activity.activityId">
                        <input type="checkbox"
                              :id="activity.activityId + arm.ArmCode"
                              @change="toggleActivity(activity.activityId,arm.ArmCode)" />

                        <label :for="activity.activityId + arm.ArmCode" class="tree_label">
                          {{ activity.activityOrder }} : {{ activity.activityName }}
                        </label>

                        <ul>
                          <li v-for="form in formList[activity.activityId + arm.ArmCode]"
                              :key="form.templateId"
                              class="p-0">

                            <div class="form-item" @click="viewForms(form.templateId)">
                              <input type="checkbox" :id="form.templateId" @click.stop />
                              <label :for="form.templateId" class="tree_form">
                                {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                              </label>
                            </div>

                          </li>
                        </ul>
                      </li>
                    </ul>

                  </li>

                </template>
                <!-- <li v-for="visit in visitList[arm.ArmCode]" :key="visit.visitId">
                                        <div class="arm-action pt-1">

              
              <div class="position-relative">
                <button
                  :popovertarget="'visit-popup-' + visit.visitId"
                  :anchor="'visit-popup-' + visit.visitId"
                  class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-0">
                  <i class="fa fa-ellipsis-v"></i>
                  
                </button>

                <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>
                  <button class="popup-menu-block text-start" @click.prevent="visitPopup(visit.visitId, arm.ArmCode)">
                    {{ $t('navigations.edit') }}
                  </button>

                  <button class="popup-menu-block text-start" @click.prevent="deleteVisit(visit.visitId)">
                    {{ $t('navigations.delete') }}
                  </button>

                  <button class="popup-menu-block text-start" @click.prevent="openVisitActivityModal(visit.visitId)">
                    {{ $t('navigations.assign activity') }}
                  </button>
                </div>
              </div>

            </div>


                  <input type="checkbox" :id="visit.visitId" @change="toggleVisit(arm.armId, visit.visitId, vIndex)" />
                  <label class="tree_label" :for="visit.visitId">
                    {{ visit.visitNo }} : {{ visit.visitFormName }}
                  </label>

                  <ul>
                    <li v-for="activity in activityList[visit.visitId]" :key="activity.activityId">
                      <input type="checkbox" :id="activity.activityId + arm.ArmCode" @change="toggleActivity(activity.activityId,arm.ArmCode)" />
                      <label :for="activity.activityId + arm.ArmCode" class="tree_label">
                        {{ activity.activityOrder }} : {{ activity.activityName }}
                      </label>

                      <ul>
                        <li v-for="form in formList[activity.activityId + arm.ArmCode]" :key="form.templateId" class="p-0">
                          <div class="form-item" @click="viewForms(form.templateId)">
                            <input type="checkbox" :id="form.templateId" @click.stop />

                            <label :for="form.templateId" class="tree_form">
                              {{ form.templateName }} : {{ form.version }}
                            </label>
                          </div>
                        </li>

                      </ul>
                    </li>
                  </ul>
                </li> -->

                
              </ul>
            </li>

          </ul>

        </div>

      </div>
  </div>

  <!-- visit modal -->
 <manageVisitModal 
  v-if="showSiteModal" 
  :visitId="visitId" 
  :armCode="currentArmCode" 
  @visitUpdated="refreshVisitList" 
  @closeModal="closeModal()"
  @visitSaved="openVisitActivityModal" 
/>
  <!-- visit modal -->

  <!-- visit activity modal -->
  <VisitActivityModal v-if="showActivityModal" :visitId="SelectedVisitId" :version="selectedVersion"
    :fromPage="'studyProfile'" @closeModal="closeActivitModal()" />
  <!-- visit activity modal -->


  <!-- form modal -->
  <showformmodel v-if="setshowActivityFormModal" :formid="formActivityId" currentformstatus="not completed"
    @closeformModal="closeformActivityModal()" />
  <!-- form modal -->
</template>

<script src="./ArmVisitTree.js"></script>
<style>
.flex-arms {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: space-between;
}

.arm-column {
  flex: 0 0 calc(33.33% - 6px);
  max-width: calc(33.33% - 6px);
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px 12px 12px 34px !important;
  position: relative;
}


.empty-line {
  height: 20px;
}

.tree li::before,
.tree li::after {
  border: none !important;
  content: none !important;
}

.arm-action {
  position: absolute;
  top: 0;
  right: 15px;
  z-index: 10;
}

.arm-column {
  position: relative;
}

.tmf-docs-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.tmf-docs-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.tmf-docs-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.tmf-docs-popup-menu>button {
  width: 100%;
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.tmf-docs-popup-menu>.popup-menu-block:hover,
.popup-submenu>div:hover {
  background-color: #e4eaf9;
}
</style>
